import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function UnfoldLessIcon(props: IconProps) {
    return <Icon {...props} iconKey={"unfold_less"}/>
}
